module.exports = __webpack_public_path__ + "static/media/Filme-de-Poliester-Metalizado-com-Janela-350x210.2fef22cb.jpg";